import { render } from "./SuccessResponseClientRegister.vue?vue&type=template&id=1abed134"
import script from "./SuccessResponseClientRegister.vue?vue&type=script&lang=js"
export * from "./SuccessResponseClientRegister.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__